import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { ErroInesperado } from '@/app/ErroInesperado';
import { initSentry, Sentry } from '@/shared/lib/telemetry/sentry';
import '@/styles/global.css';
import '@/styles/utilities.css';

initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErroInesperado />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
